module.exports = __webpack_public_path__ + "static/media/shelter-helper.fc85dff7.png";